(function () {
  'use strict';

  var modal;
  var video;

  function getModal() {
    if (!modal) {
      modal = document.querySelector('[data-elios-ugc-modal]');
      video = modal ? modal.querySelector('.elios-ugc-stories-modal__video') : null;
    }

    return modal;
  }

  function openModal(url) {
    var node = getModal();
    if (!node || !video || !url) return;

    video.src = url;
    node.hidden = false;
    document.body.style.overflow = 'hidden';
    video.play().catch(function () {});
  }

  function closeModal() {
    var node = getModal();
    if (!node || !video) return;

    video.pause();
    video.removeAttribute('src');
    video.load();
    node.hidden = true;
    document.body.style.overflow = '';
  }

  function init() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-elios-ugc-video]');
      if (trigger) {
        event.preventDefault();
        openModal(trigger.getAttribute('data-elios-ugc-video'));
        return;
      }

      if (event.target.closest('[data-elios-ugc-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
